
import { Component, Prop } from 'nuxt-property-decorator'

import { createAmpOfferInstance, MobileOffer } from '@alao-frontend/core'
import BPSectionHeader from '../snippets/BPSectionHeader.vue'
import BPDealsGrid from './BPDealsGrid.vue'
import SimpleOfferCard from '~/components/offers/SimpleOfferCard/SimpleOfferCard.vue'

import { $api } from '~/plugins/axios'
import { OffersListAnalyticsMixin } from '~/mixins/offers-list-analytics.mixin'
import { AlButton } from '~/components/ui'
import { getExternalCompareHomeHref, getExternalCompareMobileHref } from '~/utils/external-links.utils'

@Component({
  components: {
    AlButton,
    BPSectionHeader,
    BPDealsGrid,
    SimpleOfferCard,
  },
})
export default class BPMobileDeals extends OffersListAnalyticsMixin {
  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: String, required: true })
  subTitle!: string

  isOffersLoading = true
  offers: MobileOffer[] = []

  get externalCompareMobileHref (): string {
    return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath)
  }

  async fetchOffers () {
    this.isOffersLoading = true

    try {
      this.offers = (await $api.PublicOfferService.searchOffers({
        product_type: 'mobile',
        mobile_unlimited_calls_in_ch: true,
        limit: 4,
      })).items.map(item => createAmpOfferInstance(item))

      this.isOffersLoading = false
    } catch (error: any) {
      this.$notify({
        title: 'Error',
        message: error.message,
        duration: 3000,
      })
    }
  }

  async mounted (): Promise<void> {
    await this.fetchOffers()
  }
}
